import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { getAllThematics } from 'app/Api Calls/GnosiakiCalls';
import { fetchAllCarriers, getAllQuestionsAndAnswers } from 'app/Api Calls/CarriersThematicsCalls';

export default function ExportToExcelAll() {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const [thematicsData, carriersData, qnaData] = await Promise.all([
        getAllThematics(),
        fetchAllCarriers(),
        getAllQuestionsAndAnswers()
      ]);

      const tempFlatData: any[] = [];
      const sortedCarriers = carriersData.slice().sort((a,b) => a.id - b.id);

      const processLeaf = (
          carrier: any,
          thematic?: any,
          subThematic?: any,
          subSubThematic?: any
      ) => {
        tempFlatData.push({
          'Φορέας ID': carrier.id,
          'Φορέας': carrier.title,
          'Φορέας IsActive': carrier.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
          'Θεματική Ενότητα ID': thematic?.id ?? '',
          'Θεματική Ενότητα': thematic?.title ?? '',
          'Θεματική Ενότητα IsActive': thematic?.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
          'Θέμα ID': subThematic?.id ?? '',
          'Θέμα': subThematic?.title ?? '',
          'Θέμα IsActive': subThematic?.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
          'Υποθέμα ID': subSubThematic?.id ?? '',
          'Υποθέμα': subSubThematic?.title ?? '',
          'Υποθέμα IsActive': subSubThematic?.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
        });
      };

      sortedCarriers.forEach(carrier => {
        const tops = thematicsData.filter(t => t.carrierId === carrier.id && !t.parentId);
        tops.forEach(thematic => {
          const subs = thematicsData.filter(st => st.parentId === thematic.id);
          if (subs.length === 0) {
            processLeaf(carrier, thematic);
          } else {
            subs.forEach(sub => {
              const subSubs = thematicsData.filter(ss => ss.parentId === sub.id);
              if (subSubs.length === 0) {
                processLeaf(carrier, thematic, sub);
              } else {
                subSubs.forEach(ss => processLeaf(carrier, thematic, sub, ss));
              }
            });
          }
        });
      });

      if (tempFlatData.length) {
        const ws = XLSX.utils.json_to_sheet(tempFlatData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'gnosiaki_export.xlsx');
      } else {
        console.warn('No rows to export');
      }
    } catch (err) {
      console.error('Export failed', err);
    } finally {
      setExporting(false);
    }
  };

  return (
      <>
        <Button
            variant="contained"
            disabled={exporting}
            sx={{ backgroundColor: '#1b5e20 !important' }}
            onClick={handleExport}
        >
          {exporting ? 'Εξαγωγή…' : 'Εξαγωγή σε EXCEL Όλης της Γνωσιακής'}
        </Button>

        {/* Full-screen blocking backdrop with spinner */}
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={exporting}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
  );
}
